

namespace MapConstants{
export const FEATURE_NAME= "featureType";
export enum FEATURE_TYPE{blast_polygone, hole, controlPoint, site_polygone, zone_of_interest};
export const EPSG_REFERENCE_OL = 'EPSG:3857';
export const EPSG_WGS84 = 'EPSG:4326';
export const COULEUR_VIOLET_EPC = "330,100%,25%";
export const TIR_ID = 'tirId';
export const HOLE_NAME= "holeName";
export const HOLE_ID= "holeId";
export const HOLE_OBJECT= "holeObject";
export const POINT_NAME= "pointName";
export const POLYGONE_TYPE = "polyType";
export const POLYGONE_STYLE_TYPE = "polyStyleType";
export const DANGERZONEID = 4;
export const BLAST_NAME = "blastName";
export const COLOR = "color";	
export const KPI = "kpi";
export const EQUIP_TYPE = 'equipmentType';
export const POSITION_DATA = 'positionData';
export const DEFAULT_ZOOM_LEVEL = 12;
export const DEFAULT_CENTER = [0, 0];
export const POLYGONE_ID = 'blastPolygonId';
export const HOVER_FILL_COLOR = '_hoverFillColor';
export const ZOI_DATA = 'zoiData';
}
export default MapConstants;